import { z } from 'zod'

export const jsonResponsiveImageSchema = z.object({
	src: z.string(),
	srcset: z.string(),
	sizes: z.string(),
	alt: z.string(),
	title: z.string().nullish(),
	width: z.null().or(z.number()),
	height: z.null().or(z.number()),
})

export type jsonResponsiveImageSchemaType = z.infer<typeof jsonResponsiveImageSchema>
